import $ from 'jquery';

export default function hideAndShowMobileSearch() {
    const
        $mobileSiteSearchToggle = $('#mobile-site-search-toggle'),
        $mobileSiteSearchForm = $('#mobile-site-search');

    $mobileSiteSearchToggle.on('click', function() {
        if ($mobileSiteSearchForm.css('display') === 'none') {
            $mobileSiteSearchForm.slideDown();
            $mobileSiteSearchToggle.attr('aria-expanded', 'true');
        } else {
            $mobileSiteSearchForm.slideUp();
            $mobileSiteSearchToggle.attr('aria-expanded', 'false');
        }
    });
}
